// extracted by mini-css-extract-plugin
export default {"input_wrapper":"TextArea_input_wrapper__ABSNR","has_error":"TextArea_has_error__A3idN","error":"TextArea_error__nyEaH"};